import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import UIText from './uiText';
import UIValidation from './uiValidation';
import UIValue from './uiValue';
function UIPresentationDesignComponent({ title = 'Presentation Design', templateName, onClick, previewColor = '#145E73', frameColor = '#F97316', image }) {
    const styles = {
        section: {
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            width: '100%',
            boxSizing: 'border-box',
            alignItems: 'center',
        },
        title: {
            fontSize: 22,
            fontWeight: 600,
            color: '#111827',
            margin: 0,
        },
        layout: {
            display: 'flex',
            gap: 24,
            marginTop: 16,
            alignItems: 'center',
            flexWrap: 'wrap',
            justifyContent: 'center',
        },
        leftCol: {
            width: 320,
            maxWidth: '100%',
        },
        previewFrame: {
            border: `4px solid ${frameColor}`,
            borderRadius: 3,
            width: '100%',
            aspectRatio: '16 / 9',
            background: image ? 'transparent' : previewColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
            minHeight: '120px',
            maxHeight: '200px',
        },
        caption: {
            marginTop: 8,
            fontSize: 14,
            fontWeight: 600,
            color: '#1F2937',
            textAlign: 'center',
        },
        rightCol: {
            flex: 1,
            minWidth: 260,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        paragraph: {
            fontSize: 15,
            lineHeight: 1.6,
            color: '#374151',
            margin: 0,
        },
        highlight: {
            color: '#EA580C',
            fontWeight: 700,
        },
        buttonWrap: { marginTop: 14 },
        button: {
            appearance: 'none',
            border: '1px solid #D1D5DB',
            background: '#E5E7EB',
            color: '#1F2937',
            fontSize: 14,
            fontWeight: 600,
            padding: '8px 14px',
            borderRadius: 6,
            cursor: 'pointer',
            boxShadow: '0 1px 0 rgba(0,0,0,0.04)',
            transition: 'background 120ms ease, transform 60ms ease',
        },
    };
    return (_jsxs("section", { style: styles.section, children: [_jsx("h2", { style: styles.title, children: title }), _jsxs("div", { style: styles.layout, children: [_jsxs("figure", { style: styles.leftCol, children: [_jsxs("div", { style: styles.previewFrame, children: [image ? (_jsx("img", { src: image, alt: `${templateName} preview`, style: {
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            borderRadius: 2,
                                        }, onError: (e) => {
                                            e.currentTarget.style.display = 'none';
                                            const fallback = e.currentTarget.nextElementSibling;
                                            if (fallback) {
                                                fallback.style.display = 'flex';
                                            }
                                        } })) : null, _jsx("div", { style: {
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            display: image ? 'none' : 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#6B7280',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                            padding: '20px',
                                            boxSizing: 'border-box',
                                        }, children: _jsx("span", { children: "Template Preview" }) })] }), _jsx("figcaption", { style: styles.caption, children: templateName })] }), _jsx("div", { style: styles.rightCol, children: _jsx("button", { type: "button", style: styles.button, onMouseDown: (e) => (e.currentTarget.style.transform = 'translateY(1px)'), onMouseUp: (e) => (e.currentTarget.style.transform = 'translateY(0)'), onMouseEnter: (e) => (e.currentTarget.style.background = '#D1D5DB'), onMouseLeave: (e) => (e.currentTarget.style.background = '#E5E7EB'), onClick: onClick, children: "Change Template" }) })] })] }));
}
export default class UIFormatTemplateSelection extends UIValue {
    title;
    templateName;
    subtitle;
    image;
    text;
    onClick;
    borderColor;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title', 'Presentation Design');
        this.templateName = this.getProperty('templateName', 'Default Template');
        this.subtitle = this.getProperty('subtitle', '');
        this.image = s.image || this.getProperty('image', '');
        this.value = false;
        if ('text' in s) {
            this.text = new UIText(s);
        }
        this.borderColor = '#d9d9d9';
        this.onClick = () => { };
    }
    getComponent() {
        const text = this.text !== undefined ? this.text.getComponent() : null;
        const props = {
            title: this.title,
            templateName: this.templateName,
            subtitle: this.subtitle,
            image: this.image || undefined,
            borderColor: this.borderColor,
            text: text,
            selected: this.value,
            onClick: this.onClick,
        };
        return (_jsx(UIValidation, { error: this.error, children: _jsx(UIPresentationDesignComponent, { ...props }) }));
    }
}
//# sourceMappingURL=uiFormatTemplateSelection.js.map